import { useQuery } from '@tanstack/react-query';
import { useNostr } from '@nostrify/react';
import { MUSIC_TRACK_KIND, parseMusicTrack, type MusicTrack } from '@/lib/musicTypes';

export function useMusicTracksByAuthor(pubkey: string) {
  const { nostr } = useNostr();

  return useQuery({
    queryKey: ['music-tracks-by-author', pubkey],
    queryFn: async (c) => {
      if (!pubkey) return [];

      const signal = AbortSignal.any([c.signal, AbortSignal.timeout(5000)]);
      
      const events = await nostr.query(
        [{ kinds: [MUSIC_TRACK_KIND], authors: [pubkey] }],
        { signal }
      );

      // Parse and filter valid tracks
      const tracks = events
        .map(parseMusicTrack)
        .filter((track): track is MusicTrack => track !== null);

      // Sort by newest first
      tracks.sort((a, b) => b.createdAt - a.createdAt);

      return tracks;
    },
    enabled: !!pubkey,
  });
}
